module.exports = __webpack_public_path__ + "static/media/bathing.c5cc6106.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activities/bathing.svg
// module id = 1473
// module chunks = 31